/** @format */

import AllBookings from "../pages/All Bookings/AllBookings.jsx";
import Banners from "../pages/Banners/Banners.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import FirstPage from "../pages/FirstPage/FirstPage.jsx";
import ForgotPassword from "../pages/Login/ForgotPassword.jsx";
import Login from "../pages/Login/Login.jsx";
import SetPassword from "../pages/Login/SetPassword.jsx";
import Verifycode from "../pages/Login/Verifycode.jsx";
import MonthlySubscription from "../pages/Monthly Subscription/MonthlySubscription.jsx";
import PartnerLists from "../pages/Partner Lists/PartnerLists.jsx";
import PayoutManagement from "../pages/Payout Management/PayoutManagement.jsx";
import PartnerReferralhistory from "../pages/Referral History/PartnerReferralhistory.jsx";
import UserReferralhistory from "../pages/Referral History/UserReferralhistory.jsx";
import SubAdmin from "../pages/Sub Admin/SubAdmin.jsx";
import CreditBalance from "../pages/Transaction Lists/Partner Transaction/CreditBalance.jsx";
import SubscriptionTransaction from "../pages/Transaction Lists/Partner Transaction/SubscriptionTransaction.jsx";
import TrainingFees from "../pages/Transaction Lists/Partner Transaction/TrainingFees.jsx";
import ServiceTransaction from "../pages/Transaction Lists/User Transaction/ServiceTransaction.jsx";
import UsersLists from "../pages/Users Lists/UsersLists.jsx";
import PayoutCreditBalance from "../pages/Payout Management/CreditBalance.jsx";
import Offers from "../pages/Offers & Coupons/Offers.jsx";
import Coupons from "../pages/Offers & Coupons/Coupons.jsx";
import PushNotification from "../pages/Push Notification/PushNotification.jsx";
import Privacypolicy from "../pages/Policy Setting/Privacypolicy.jsx";
import TermsandConditions from "../pages/Policy Setting/TermsandConditions.jsx";
import FAQ from "../pages/Help & Support/FAQ.jsx";
import TicketRaised from "../pages/Help & Support/TicketRaised.jsx";
import ContactSupport from "../pages/Help & Support/ContactSupport.jsx";
import ServiceManagement from "../pages/Service Management/ServiceManagement.jsx";
import UserProfile from "../pages/Users Lists/UserProfile.jsx";
import UserPayment from "../pages/Users Lists/UserPayment.jsx";
import UsersBookings from "../pages/Users Lists/UsersBookings.jsx";
import UserWalletdetails from "../pages/Users Lists/UserWalletdetails.jsx";
import UserReferralList from "../pages/Users Lists/UserReferralList.jsx";
import UserAddress from "../pages/Users Lists/UserAddress.jsx";
import PartnerProfile from "../pages/Partner Lists/PartnerProfile.jsx";
import PartnerPayment from "../pages/Partner Lists/PartnerPayment.jsx";
import PartnerDocument from "../pages/Partner Lists/PartnerDocument.jsx";
import PartnerBookings from "../pages/Partner Lists/PartnerBookings.jsx";
import PartnerPerformance from "../pages/Partner Lists/PartnerPerformance.jsx";
import PartnerCreditBalance from "../pages/Partner Lists/PartnerCreditBalance.jsx";
import PartnerHub from "../pages/Partner Lists/PartnerHub.jsx";
import BookingDetails from "../pages/All Bookings/BookingDetails.jsx";
import AddService from "../pages/Service Management/AddService.jsx";
import AddCategory from "../pages/Service Management/AddCategory.jsx";
import AddSubCategory from "../pages/Service Management/SubCategories/AddSubCategory.jsx";
import EditService from "../pages/Service Management/EditService.jsx";
import EditCategory from "../pages/Service Management/EditCategory.jsx";
import EditSubCategory from "../pages/Service Management/SubCategories/EditSubCategory.jsx";
import ServiceDetails from "../pages/Service Management/ServiceDetails.jsx";
import WalletDetail from "../pages/Wallet/WalletDetail.jsx";
import AddPlan from "../pages/Monthly Subscription/AddPlan.jsx";
import EditPlan from "../pages/Monthly Subscription/EditPlan.jsx";
import PlanDetails from "../pages/Monthly Subscription/PlanDetails.jsx";
import AddBanner from "../pages/Banners/AddBanner.jsx";
import EditBanner from "../pages/Banners/EditBanner.jsx";
import ViewBanner from "../pages/Banners/ViewBanner.jsx";
import AddOffers from "../pages/Offers & Coupons/AddOffers.jsx";
import EditOffers from "../pages/Offers & Coupons/EditOffers.jsx";
import ViewofferDetail from "../pages/Offers & Coupons/ViewofferDetail.jsx";
import Addcoupon from "../pages/Offers & Coupons/Addcoupon.jsx";
import Editcoupon from "../pages/Offers & Coupons/Editcoupon.jsx";
import Viewcoupon from "../pages/Offers & Coupons/Viewcoupon.jsx";
import Createnewpolicy from "../pages/Policy Setting/Createnewpolicy.jsx";
import Editprivacypolicy from "../pages/Policy Setting/Editprivacypolicy.jsx";
import Createnewterms from "../pages/Policy Setting/Createnewterms.jsx";
import CreatenewFAQ from "../pages/Help & Support/CreatenewFAQ.jsx";
import EditTerms from "../pages/Policy Setting/EditTerms.jsx";
import EditFAQ from "../pages/Help & Support/EditFAQ.jsx";
import TicketraisedDetails from "../pages/Help & Support/TicketraisedDetails.jsx";
import Createcontactsupport from "../pages/Help & Support/Createcontactsupport.jsx";
import Editcontactsupport from "../pages/Help & Support/Editcontactsupport.jsx";
import AddnewSubAdmin from "../pages/Sub Admin/AddnewSubAdmin.jsx";
import EditnewSubAdmin from "../pages/Sub Admin/EditnewSubAdmin.jsx";
import ViewSubAdmin from "../pages/Sub Admin/ViewSubAdmin.jsx";
import LiveChat from "../pages/Live Chat/LiveChat.jsx";
import Settings from "../pages/Settings/Settings.jsx";
import Changepassword from "../pages/Settings/Changepassword.jsx";
import ServiceCategoryDetails from "../pages/Service Management/ServiceCategoryDetails.jsx";
import AllMainCategoryType from "../pages/Service Management/MainCategoryType/AllMainCategoryType.jsx";
import AllCategory from "../pages/Service Management/Category/AllCategory.jsx";
import SubCategories from "../pages/Service Management/SubCategories/SubCategories.jsx";
import AllServices from "../pages/Service Management/Services/AllServices.jsx";
import AddServices from "../pages/Service Management/Services/AddServices.jsx";
import EditServices from "../pages/Service Management/Services/EditServices.jsx";
import ViewService from "../pages/Service Management/Services/ViewService.jsx";
import ServiceDetailsbyid from "../pages/Service Management/ServiceDetailsbyid.jsx";
import AllMainCatgoryBanner from "../pages/Main Category Banner/AllMainCatgoryBanner.jsx";
import AddMainCategorybanner from "../pages/Main Category Banner/AddMainCategorybanner.jsx";
import BannerCategory from "../pages/Category Banner/BannerCategory.jsx";
import AddBannerCategory from "../pages/Category Banner/AddBannerCategory.jsx";
import Packages from "../pages/Packages/Packages.jsx";
import AddPackages from "../pages/Packages/AddPackages.jsx";
import Slot from "../pages/Slot/Slot.jsx";
import BookedSessions from "../pages/Booked Sessions/BookedSessions.jsx";
import MainCategoryFAQ from "../pages/Help & Support/MainCategoryFAQ.jsx";
import AddMainCategoryFAQ from "../pages/Help & Support/AddMainCategoryFAQ.jsx";
import EditMainCategoryFAQ from "../pages/Help & Support/EditMainCategoryFAQ.jsx";
import SubAdminpermission from "../pages/Sub Admin/SubAdminpermission.jsx";
import AdminProfile from "../pages/Admin Profile/AdminProfile.jsx";
import SubadminLogin from "../pages/Login/SubadminLogin.jsx";
import City from "../pages/Location/City.jsx";
import Area from "../pages/Location/Area.jsx";
import Charges from "../pages/Charges/Charges.jsx";
import TrainingVideos from "../pages/Training Videos/TrainingVideos.jsx";
import Testimonial from "../pages/Testimonial/Testimonial.jsx";
import Leaves from "../pages/Leaves/Leaves.jsx";
import InsurancePlans from "../pages/Insurance Plans/InsurancePlans.jsx";
import EditPackages from "../pages/Packages/EditPackages.jsx";
import UserWallet from "../pages/Wallet/UserWallet.jsx";
import PartnerWallet from "../pages/Wallet/PartnerWallet.jsx";
import AdminWallet from "../pages/Wallet/AdminWallet.jsx";
import AdminTransaction from "../pages/Transaction Lists/Admin Transaction/AdminTransaction.jsx";
import ConsentForms from "../pages/Consent Forms/ConsentForms.jsx";
import TraningReport from "../pages/Traning Report/TraningReport.jsx";
import ViewPackage from "../pages/Packages/ViewPackage.jsx";
import PartnerChart from "../pages/Live Chat/PartnerChart.jsx";
import AboutUs from "../pages/Policy Setting/AboutUs.jsx";
import CreateAboutUs from "../pages/Policy Setting/CreateAboutUs.jsx";
import EditAboutUs from "../pages/Policy Setting/EditAboutUs.jsx";



const allRoutes = [
  {
    route: "/",
    component: <FirstPage />,
    isProtected: false,
  },
  {
    route: "/login",
    component: <Login />,
    isProtected: false,
  },
  {
    route: "/forgotpassword",
    component: <ForgotPassword />,
  },
  {
    route: "/verifycode",
    component: <Verifycode />,
  },
  {
    route: "/setpassword",
    component: <SetPassword />,
  },
  {
    route: "/dashboard",
    component: <Dashboard />,
    isProtected: true,
  },
  {
    route: "/userslists",
    component: <UsersLists />,
    isProtected: true,
  },
  {
    route: "/partnerlists",
    component: <PartnerLists />,
    isProtected: true,
  },
  {
    route: "/allbookings",
    component: <AllBookings />,
    isProtected: true,
  },
  {
    route: "/user/wallet/",
    component: <UserWallet />,
    isProtected: true,
  },
  {
    route: "/partner/wallet",
    component: <PartnerWallet />,
    isProtected: true,
  },
  {
    route: "/admin/wallet",
    component: <AdminWallet />,
    isProtected: true,
  },
  {
    route: "/monthlysubscription",
    component: <MonthlySubscription />,
    isProtected: true,
  },
  {
    route: "/subadmin",
    component: <SubAdmin />,
    isProtected: true,
  },
  {
    route: "/transaction-lists/user-transaction",
    component: <ServiceTransaction />,
    isProtected: true,
  },

  {
    route: "/transaction-lists/partner-transaction/subscription-transaction",
    component: <SubscriptionTransaction />,
    isProtected: true,
  },
  {
    route: "/transaction-lists/partner-transaction/training-fees",
    component: <TrainingFees />,
    isProtected: true,
  },
  {
    route: "/transaction-lists/partner-transaction/service-transaction",
    component: <CreditBalance />,
    isProtected: true,
  },
  {
    route: "/transaction-lists/admin-transaction",
    component: <AdminTransaction />,
    isProtected: true,
  },
  {
    route: "/referral-history",
    component: <UserReferralhistory />,
    isProtected: true,
  },
  {
    route: "/referral-history/partner",
    component: <PartnerReferralhistory />,
    isProtected: true,
  },
  {
    route: "/banners",
    component: <Banners />,
    isProtected: true,
  },
  {
    route: "/main-category/banners",
    component: <AllMainCatgoryBanner />,
    isProtected: true,
  },
  {
    route: "/main-category/banners/add",
    component: <AddMainCategorybanner />,
    isProtected: true,
  },
  {
    route: "/category/banners",
    component: <BannerCategory />,
    isProtected: true,
  },
  {
    route: "/category/banners/add",
    component: <AddBannerCategory />,
    isProtected: true,
  },
  {
    route: "/payout-management/payoutlist",
    component: <PayoutManagement />,
    isProtected: true,
  },
  {
    route: "/payout-management/credit-balance",
    component: <PayoutCreditBalance />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/offers",
    component: <Offers />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/coupons",
    component: <Coupons />,
    isProtected: true,
  },
  {
    route: "/push-notification",
    component: <PushNotification />,
    isProtected: true,
  },
  {
    route: "/privacy-policy",
    component: <Privacypolicy />,
    isProtected: true,
  },
  {
    route: "/terms-and-conditions",
    component: <TermsandConditions />,
    isProtected: true,
  },
  {
    route: "/help-Support/support-faq",
    component: <FAQ />,
    isProtected: true,
  },
  {
    route: "/help-Support/ticket-raised",
    component: <TicketRaised />,
    isProtected: true,
  },
  {
    route: "/help-Support/contact-support",
    component: <ContactSupport />,
    isProtected: true,
  },
  {
    route: "/service-management/main-category",
    component: <ServiceManagement />,
    isProtected: true,
  },
  {
    route: "/service-management/main-category-types",
    component: <AllMainCategoryType />,
    isProtected: true,
  },
  {
    route: "/service-management/all-category",
    component: <AllCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/all-subcategory",
    component: <SubCategories />,
    isProtected: true,
  },
  {
    route: "/service-management/all-subcategory/add",
    component: <AddSubCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/all-subcategory/edit/:id",
    component: <EditSubCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/all-services",
    component: <AllServices />,
    isProtected: true,
  },
  {
    route: "/service-management/all-services/add",
    component: <AddServices />,
    isProtected: true,
  },
  {
    route: "/service-management/all-services/edit/:id",
    component: <EditServices />,
    isProtected: true,
  },
  {
    route: "/service-management/all-services/view/:id",
    component: <ViewService />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile",
    component: <UserProfile />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile/payments/:id",
    component: <UserPayment />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile/bookings/:id",
    component: <UsersBookings />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile/wallet-details/:id",
    component: <UserWalletdetails />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile/referral-list/:id",
    component: <UserReferralList />,
    isProtected: true,
  },
  {
    route: "/userslists/user-profile/address/:id",
    component: <UserAddress />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile",
    component: <PartnerProfile />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/payment/:id",
    component: <PartnerPayment />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/document/:id",
    component: <PartnerDocument />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/bookings/:id",
    component: <PartnerBookings />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/performance/:id",
    component: <PartnerPerformance />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/credit-balance/:id",
    component: <PartnerCreditBalance />,
    isProtected: true,
  },
  {
    route: "/partnerlists/partner-profile/hub/:id",
    component: <PartnerHub />,
    isProtected: true,
  },
  {
    route: "/allbookings/booking-details/:id",
    component: <BookingDetails />,
    isProtected: true,
  },
  {
    route: "/service-management/add-service",
    component: <AddService />,
    isProtected: true,
  },
  {
    route: "/service-management/:service/:id/add-category",
    component: <AddCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/add-service/add-category/add-subcategory",
    component: <AddSubCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/main-category/:id",
    component: <EditService />,
    isProtected: true,
  },
  {
    route: "/service-management/edit-service/edit-category",
    component: <EditCategory />,
    isProtected: true,
  },
  {
    route: "/service-management/:service/:id",
    component: <ServiceDetails />,
    isProtected: true,
  },
  {
    route: "/wallet/wallet-detail/:id",
    component: <WalletDetail />,
    isProtected: true,
  },
  {
    route: "/monthlysubscription/add-plan",
    component: <AddPlan />,
    isProtected: true,
  },
  {
    route: "/monthlysubscription/edit-plan/:id",
    component: <EditPlan />,
    isProtected: true,
  },
  {
    route: "/monthlysubscription/plan-details/:id",
    component: <PlanDetails />,
    isProtected: true,
  },
  {
    route: "/banners/add-banner",
    component: <AddBanner />,
    isProtected: true,
  },
  {
    route: "/banners/edit-banner",
    component: <EditBanner />,
    isProtected: true,
  },
  {
    route: "/banners/view-banner/:id",
    component: <ViewBanner />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/offers/add-offer",
    component: <AddOffers />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/offers/edit-offer",
    component: <EditOffers />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/offers/view-offer",
    component: <ViewofferDetail />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/coupons/add-coupon",
    component: <Addcoupon />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/coupons/edit-coupon",
    component: <Editcoupon />,
    isProtected: true,
  },
  {
    route: "/offers_coupons/coupons/view-coupon",
    component: <Viewcoupon />,
    isProtected: true,
  },
  {
    route: "/privacy-policy/add-privacy-policy",
    component: <Createnewpolicy />,
    isProtected: true,
  },
  {
    route: "/privacy-policy/edit/:id",
    component: <Editprivacypolicy />,
    isProtected: true,
  },
  {
    route: "/terms-and-conditions/add-terms-and-conditions",
    component: <Createnewterms />,
    isProtected: true,
  },
  {
    route: "/terms-and-conditions/edit/:id",
    component: <EditTerms />,
    isProtected: true,
  },
  {
    route: "/help-Support/support-faq/add-faq",
    component: <CreatenewFAQ />,
    isProtected: true,
  },
  {
    route: "/help-Support/support-faq/edit/:id",
    component: <EditFAQ />,
    isProtected: true,
  },
  {
    route: "/help-Support/ticket-raised/details/:id",
    component: <TicketraisedDetails />,
    isProtected: true,
  },
  {
    route: "/help-Support/contact-support/add-contact-support",
    component: <Createcontactsupport />,
    isProtected: true,
  },
  {
    route: "/help-Support/contact-support/edit-contact-support",
    component: <Editcontactsupport />,
    isProtected: true,
  },
  {
    route: "/subadmin/add-subadmin",
    component: <AddnewSubAdmin />,
    isProtected: true,
  },
  {
    route: "/subadmin/edit/:id",
    component: <EditnewSubAdmin />,
    isProtected: true,
  },
  {
    route: "/subadmin/view/:id",
    component: <ViewSubAdmin />,
    isProtected: true,
  },
  {
    route: "/subadmin/permission/:id",
    component: <SubAdminpermission />,
    isProtected: true,
  },
  {
    route: "/live-chat/user",
    component: <LiveChat />,
    isProtected: true,
  },
  {
    route: "/live-chat/partner",
    component: <PartnerChart />,
    isProtected: true,
  },
  {
    route: "/settings",
    component: <Settings />,
    isProtected: true,
  },
  {
    route: "/settings/change-password",
    component: <Changepassword />,
    isProtected: true,
  },
  {
    route: "service-management/service-details/:id/:category/:categoryid",
    component: <ServiceCategoryDetails />,
    isProtected: true,
  },

  {
    route: "service-management/service-details/:id/:category/:categoryid/subcategory/:subcategoryid",
    component: <ServiceDetailsbyid />,
    isProtected: true,
  },

  {
    route: "/allpackages",
    component: <Packages />,
    isProtected: true,
  },
  {
    route: "/allpackages/add",
    component: <AddPackages />,
    isProtected: true,
  },
  {
    route: "/allpackages/edit/:id",
    component: <EditPackages />,
    isProtected: true,
  },

  {
    route: "/slot",
    component: <Slot />,
    isProtected: true,
  },
  {
    route: "/booked-sessions",
    component: <BookedSessions />,
    isProtected: true,
  },
  {
    route: "/help-Support/maincategory-faq",
    component: <MainCategoryFAQ />,
    isProtected: true,
  },
  {
    route: "/help-Support/maincategory-faq/add",
    component: <AddMainCategoryFAQ />,
    isProtected: true,
  },
  {
    route: "/help-Support/maincategory-faq/edit/:id",
    component: <EditMainCategoryFAQ />,
    isProtected: true,
  },
  {
    route: "/admin-profile",
    component: <AdminProfile />,
    isProtected: true,
  },

  {
    route: "/sub-admin-login",
    component: <SubadminLogin />,
    isProtected: false,
  },
  {
    route: "/location/cities",
    component: <City />,
    isProtected: true,
  },
  {
    route: "/location/areas",
    component: <Area />,
    isProtected: true,
  },
  {
    route: "/charges",
    component: <Charges />,
    isProtected: true,
  },
  {
    route: "/training-videos",
    component: <TrainingVideos />,
    isProtected: true,
  },
  {
    route: "/testimonial",
    component: <Testimonial />,
    isProtected: true,
  },
  {
    route: "/leaves",
    component: <Leaves />,
    isProtected: true,
  },
  {
    route: "/insurance-plans",
    component: <InsurancePlans />,
    isProtected: true,
  },

  {
    route: "/consent-forms",
    component: <ConsentForms />,
    isProtected: true,
  },
  {
    route: "/traning-reports",
    component: <TraningReport />,
    isProtected: true,
  },
  {
    route: "/allpackages/view/:id",
    component: <ViewPackage />,
    isProtected: true,
  },

  {
    route: "/about-us",
    component: <AboutUs />,
    isProtected: true,
  },

  {
    route: "/about-us/add",
    component: <CreateAboutUs />,
    isProtected: true,
  },

  {
    route: "/about-us/edit/:id",
    component: <EditAboutUs />,
    isProtected: true,
  },

];

export default allRoutes;